import { MultiSelectButtonContext } from "./multi-select-button-context";
export const MultiSelectButtonConsumer = MultiSelectButtonContext.Consumer;